export default __webpack_public_path__ + "static/media/concavelens.3dd4eba5.jpg";